import { render, staticRenderFns } from "./IdentityMapLink.vue?vue&type=template&id=5f14ec1d&scoped=true&"
import script from "./IdentityMapLink.vue?vue&type=script&lang=js&"
export * from "./IdentityMapLink.vue?vue&type=script&lang=js&"
import style0 from "./IdentityMapLink.vue?vue&type=style&index=0&id=5f14ec1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f14ec1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f14ec1d')) {
      api.createRecord('5f14ec1d', component.options)
    } else {
      api.reload('5f14ec1d', component.options)
    }
    module.hot.accept("./IdentityMapLink.vue?vue&type=template&id=5f14ec1d&scoped=true&", function () {
      api.rerender('5f14ec1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/IdentityMap/IdentityMapLink.vue"
export default component.exports